import { render, staticRenderFns } from "./GroupsEntrees.vue?vue&type=template&id=49d7947d&"
import script from "./GroupsEntrees.vue?vue&type=script&lang=js&"
export * from "./GroupsEntrees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports